import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

export function AdminPagination({
  page,
  pageSize,
  total,
  onPageChange,
}: {
  page: number;
  pageSize: number;
  total: number;
  onPageChange: (page: number) => void;
}) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const safePage = Math.min(page, totalPages);
  return (
    <div className="flex items-center justify-end gap-1 px-3 py-2 border-t border-gray-100">
      <button
        type="button"
        aria-label="Предыдущая"
        title="Предыдущая"
        disabled={safePage <= 1}
        onClick={() => onPageChange(safePage - 1)}
        className="p-1.5 rounded-lg text-gray-500 hover:bg-gray-100 disabled:opacity-30 disabled:hover:bg-transparent"
      >
        <ChevronLeft size={16} />
      </button>
      <span className="min-w-[4.5rem] text-center text-[12px] text-gray-500 tabular-nums">
        {safePage} / {totalPages}
      </span>
      <button
        type="button"
        aria-label="Следующая"
        title="Следующая"
        disabled={safePage >= totalPages}
        onClick={() => onPageChange(safePage + 1)}
        className="p-1.5 rounded-lg text-gray-500 hover:bg-gray-100 disabled:opacity-30 disabled:hover:bg-transparent"
      >
        <ChevronRight size={16} />
      </button>
    </div>
  );
}
